import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { DepartmentTableColumn } from "../../../Data/DataTables/Departments";
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewDepartments } from "../../../Types/CompanyProfile/Department";

//Modal
import CreateDepartmentModal from "../../UiKits/Modal/Department/Create";

//Services
import {
  VIEW_DEPARTMENT_QUERY_KEY,
  departmentService,
} from "../../../Services/departmentService";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const DepartmentTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const departmentQueryKey = [...VIEW_DEPARTMENT_QUERY_KEY, company_code];

  const { data: DepartmentData = [], isLoading: isDepartmentLoading } =
    useQuery<ViewDepartments[]>({
      queryKey: departmentQueryKey,
      queryFn: () =>
        departmentService.getAllViewDepartmentByCompany(company_code as string),
    });

  const filteredItems: ViewDepartments[] = DepartmentData.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Department Maintenance</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Allows users to create, update, and manage department records, with each
        department assigned to a specific division to maintain proper
        organizational structure.
      </P>
      <CreateDepartmentModal company_code={company_code} />
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={DepartmentTableColumn}
          striped={true}
          pagination
          progressPending={isDepartmentLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default DepartmentTable;
